import { ACCEPTED_FILE_MIME_TYPES, ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from '@/constants'
import { createMultipleFilesSchema, enumSchema, stringSchema, objectSchema, dateTimeSchema } from '@/schemas'
import { FeedTypeEnum } from '@/types'

export const baseFeedSchema = objectSchema({
  id: stringSchema.optional(),
  type: enumSchema(Object.values(FeedTypeEnum)),
})

export const feedCallNoteSchema = baseFeedSchema.extend({
  datetime: dateTimeSchema,
  note: stringSchema.optional(),
})

export const feedUpdateCallNoteSchema = feedCallNoteSchema.extend({
  datetime: dateTimeSchema.optional(),
})

export const feedNoteSchema = baseFeedSchema.extend({
  note: stringSchema.optional(),
})

export const feedFileSchema = baseFeedSchema.extend({
  files: createMultipleFilesSchema({
    required: true,
    maxSize: MAX_FILE_SIZE,
    acceptedMimeTypes: ACCEPTED_FILE_MIME_TYPES,
    acceptedTypesDescription: ACCEPTED_FILE_TYPES,
  }),
})
